import { z } from 'zod';

export const CommentEditDataSchema = z.object({
  text: z.string().min(1, { message: 'Required' }),
});

export type CommentEditData = z.infer<typeof CommentEditDataSchema>;
